export default {"src":"/_next/static/media/Playstore.fed02a75.svg","height":44,"width":148,"blurWidth":0,"blurHeight":0};